import { Switch, useRouteMatch } from "polyrouter";
import React, { useContext } from "react";
import { DeviceUserGroupDetailsRouter } from "./Details/DeviceUserGroupDetailsRouter";
import { ProtectedRoute } from "TsRoleGuards";
import { SelectedTenantContext } from "polyrouter/SelectedTenantProvider";
import DeviceUserGroupList from "./List/DeviceUserGroupList";

export const DeviceUserGroupRouter: React.FC = () => {
  const root = useRouteMatch().path;
  const { tenant } = useContext(SelectedTenantContext);
  return (
    <Switch>
      <ProtectedRoute
        path={`${root}/details/:id`}
        requirement={"read:usergroup"}
      >
        <DeviceUserGroupDetailsRouter />
      </ProtectedRoute>
      <ProtectedRoute path={root} requirement={"read:usergroup"}>
        <>{tenant && <DeviceUserGroupList tenant={tenant} />}</>
      </ProtectedRoute>
    </Switch>
  );
};

export default DeviceUserGroupRouter;
